import { z } from "zod";

export const DisciplinaItemChecklistSchema = z.object({
  idDisciplinaItensChecklist: z.number().optional(),
  inspecao: z.string().optional(),
  descricao: z.string().optional(),
  itens: z.string().optional(),
});

export type DisciplinaItemChecklistForm = z.infer<typeof DisciplinaItemChecklistSchema>;


